import { createFilterBuilders } from '../../../shared/utils/tableFilterFactories'
import { FilterDefinition } from '../../../shared/utils/tableFilters'
import { toListLabel } from '../../../shared/utils/displayValue'
import { StrategicImperative } from '../../../shared/queries/strategicImperatives'
import { getLinkedActivityCount, getLinkedValueMessageCount } from './StrategicImperativeTable.helpers'
import { StrategicImperativeColumnId, StrategicImperativeDisplayNames } from './StrategicImperativeTable.types'

export const getStrategicImperativeFilterDefinitions = (
    { activities, valueMessages }: StrategicImperativeDisplayNames,
    defaultVisibleColumnIds?: ReadonlySet<StrategicImperativeColumnId>
): FilterDefinition<StrategicImperative>[] => {
    const { multiValueFilter, linkedFilter } = createFilterBuilders<StrategicImperative, StrategicImperativeColumnId>(
        defaultVisibleColumnIds
    )

    return [
        multiValueFilter('audiences', 'Audiences', (row) => row.audiences),
        linkedFilter('linkedActivities', `Linked ${activities}`, getLinkedActivityCount),
        linkedFilter('linkedValueMessages', `Linked ${valueMessages}`, getLinkedValueMessageCount),
    ]
}

export const getStrategicImperativeSearchValues = (row: StrategicImperative) => ({
    name: row.name,
    audiences: toListLabel(row.audiences),
})
